import { Component, OnInit, Injector, ApplicationRef, ComponentFactoryResolver, ComponentRef } from '@angular/core';
import { MapService } from './map.service';

@Component({
  selector: 'leaflet-map',
  template: '<div id="map" style="height: 495px"></div>',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {

  constructor(public mapService: MapService,
    private readonly injector: Injector,
    private readonly appRef: ApplicationRef,
    private readonly resolver: ComponentFactoryResolver) {
  }

  ngOnInit() {
    this.mapService.initMap('map');
  }

}
